import React from 'react';
import { ShieldCheck } from 'lucide-react';
import styles from './PECoatedRollHero.module.css';

const PECoatedRollHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
  stampLabel = 'PE Coated',
}) => (
  <section className={styles.heroSection}>
    <div className={styles.coatingSheen} aria-hidden="true" />

    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>{mainTitleLines.join(' ')}</h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureRow}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureChip}>
                  <ShieldCheck size={12} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.visualCol}>
          <div className={styles.visualPanel}>
            <div className={styles.imageStack}>
              {imagePrimary && (
                <figure className={styles.primaryFrame}>
                  <img src={imagePrimary.src} alt={imagePrimary.alt} />
                </figure>
              )}

              {imageSecondary && (
                <figure className={styles.secondaryFrame}>
                  <img src={imageSecondary.src} alt={imageSecondary.alt} />
                </figure>
              )}

              {stampLabel && (
                <div className={styles.coatingBadge}>
                  <ShieldCheck size={13} aria-hidden="true" />
                  <span>{stampLabel}</span>
                </div>
              )}

              <span className={styles.accentBar} aria-hidden="true" />
              <span className={styles.accentCorner} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PECoatedRollHero;
